module.exports = __webpack_public_path__ + "static/media/400034_02.5d005d39.png";